import * as React from 'react'

export const SubscriptIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_subscript)'>
        <path
          d='M16.5843 20.6997V19.2032L20.4112 16.2026C20.7294 15.9519 21.0026 15.7238 21.2307 15.5183C21.4588 15.3077 21.6338 15.1021 21.7558 14.9016C21.8778 14.696 21.9388 14.4729 21.9388 14.2323C21.9388 13.8412 21.7743 13.5354 21.4455 13.3148C21.1166 13.0942 20.7135 12.9839 20.2362 12.9839C19.727 12.9839 19.3159 13.1068 19.003 13.3524C18.6953 13.5931 18.5415 13.929 18.5415 14.3601H16.4331C16.4331 13.4276 16.7911 12.6932 17.5072 12.1567C18.2286 11.6152 19.1488 11.3445 20.268 11.3445C21.0265 11.3445 21.6868 11.4724 22.2491 11.7281C22.8166 11.9787 23.2568 12.3196 23.5698 12.7508C23.8827 13.182 24.0392 13.6658 24.0392 14.2022C24.0392 14.6334 23.9464 15.0345 23.7607 15.4055C23.5751 15.7714 23.286 16.1399 22.8935 16.5109C22.501 16.8769 21.9998 17.273 21.3898 17.6991L19.7508 18.9324V19.0001H24.2142V20.6997H16.5843Z'
          fill='currentColor'
        />
        <path
          d='M5.71618 1.19971L9.00207 6.44884H9.12937L12.4312 1.19971H16.3217L11.3491 8.90044L16.4331 16.6012H12.471L9.12937 11.3445H9.00207L5.66048 16.6012H1.71423L6.81413 8.90044L1.80971 1.19971H5.71618Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_subscript'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

SubscriptIcon.displayName = 'SubscriptIcon'
